import { Button, Paper, styled, Typography } from "@mui/material";

export const StyledProvider = {
  TableContainer: styled("div")(({ theme }) => ({
    overflow: "hidden",
    position: "relative",
  })),
  ScrollContainer: styled("div")(({ theme }) => ({
    overflowY: "auto",
    overflowX: "hidden",
    height: "100%",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  })),
  ArtInProviderContainer: styled("div")(({ theme }) => ({
    backgroundColor: "#fafafa",
    padding: 10,
  })),
};

export const StyledAttentionsInAnotherPtovidersCards = {
  Container: styled("div")({
    display: "flex",
    flexDirection: "column",
    height: 100,
    overflow: "auto",
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 2,
    paddingBottom: 5,
  }),

  Card: styled(Paper)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 10,
    padding: 5,
    paddingLeft: 10,
    borderRadius: 5,
  }),

  Button: styled("div")({
    cursor: "pointer",
  }),

  EmptyState: styled(Typography)({
    alignSelf: "center",
    marginTop: 20,
  }),
};

export const StyledProviderProvidedServiceForm = {
  StyledPaper: styled(Paper)({
    display: "flex",
    padding: 20,
    marginBottom: 20,
  }),
  StyledInput: styled("div")({
    display: "inline-flex",
    marginRight: 20,
    width: 250,
  }),
  StyledHorizontalInput: styled("div")({
    display: "inline-flex",
    padding: 10,
    width: "80%",
  }),
  ButtonContainer: styled("div")({
    display: "flex",
    justifyContent: "flex-end",
  }),
  StyledButton: styled(Button)(({ theme }) => ({
    margin: theme.spacing(1),
  })),
};